export default Object.freeze({
  BOOKING_DETAILS: 'BOOKING_DETAILS',
  ACTIVITY_DETAILS: 'ACTIVITY_DETAILS'
});
